/* Hand-written until the durable-turn endpoints land in the generated OpenAPI
 * client. These calls intentionally use the normal backend JWT, not the
 * AgentCore template token. */

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
import type { AgentFrame } from "./agent-types";

export type AgentTurnStatus = "running" | "completed" | "interrupted" | "failed" | "cancelled";

export interface AgentTurnInterrupt {
  question: string;
  payload: Record<string, unknown>;
  editable?: boolean;
}

export interface AgentTurnRecord {
  turn_id: string;
  client_turn_id: string;
  status: AgentTurnStatus;
  started_at: string;
  completed_at: string | null;
  frames: AgentFrame[];
  plan_updated: boolean;
  profile_updated?: boolean;
  interrupt: AgentTurnInterrupt | null;
  trace_id: string | null;
}

export interface CancelAgentTurnRequest {
  session_id: string;
  turn_id: string;
}

export interface CancelAgentTurnResponse {
  accepted: true;
}

export class AgentTurnsService {
  static getLatestAgentTurn(sessionId: string): CancelablePromise<AgentTurnRecord> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/chat/turns/latest",
      query: { session_id: sessionId },
      errors: { 404: "Turn not found" },
    });
  }

  static cancelAgentTurn(
    requestBody: CancelAgentTurnRequest,
  ): CancelablePromise<CancelAgentTurnResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/chat/turns/cancel",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: "Turn not found",
        409: "Turn is not running",
        422: "Validation Error",
      },
    });
  }
}
